import { render, staticRenderFns } from "./PicklTypeInsights.vue?vue&type=template&id=2d633808&"
import script from "./PicklTypeInsights.vue?vue&type=script&lang=js&"
export * from "./PicklTypeInsights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports